import React from "react";

// Classic space-invader style bitmaps rendered as CSS box-shadow pixel art.
const GRIDS = {
  a: [
    "00100000100",
    "00010001000",
    "00111111100",
    "01101110110",
    "11111111111",
    "10111111101",
    "10100000101",
    "00011011000",
  ],
  b: [
    "00011111000",
    "01111111110",
    "11111111111",
    "11100100111",
    "11111111111",
    "00011011000",
    "00110001100",
    "01100000110",
  ],
  c: [
    "00100100",
    "00011000",
    "00111100",
    "01111110",
    "11111111",
    "10111101",
    "10100101",
    "00011000",
  ],
};

const BOSS_GRIDS = {
  invader: [
    "0000011111111110000",
    "0001111111111111000",
    "0011111111111111100",
    "0111001111110011110",
    "1111111111111111111",
    "1111111111111111111",
    "1110011111100111111",
    "1100000110000001100",
    "0011100000000111000",
  ],
  squid: [
    "0000000111110000000",
    "0000011111111100000",
    "0001111111111111000",
    "0011111111111111100",
    "0011100111110011100",
    "0011111111111111100",
    "0001111111111111000",
    "0000110110110110000",
    "0001100110110011000",
    "0011000000000001100",
  ],
  crab: [
    "0010000000000000100",
    "0001000000000001000",
    "0001111111111111000",
    "0011101111111011100",
    "0111111111111111110",
    "1111111111111111111",
    "1011111111111111101",
    "1010000000000000101",
    "0000111000000111000",
  ],
  mothership: [
    "0000000011100000000",
    "0000001111111000000",
    "0000111111111110000",
    "0011111111111111100",
    "0111011101110111010",
    "1111111111111111111",
    "0011111111111111100",
    "0000111000000111000",
    "0000011000000110000",
  ],
};

const SHIP_GRID = [
  "0000100000",
  "0000110000",
  "0001111000",
  "0001111000",
  "0011111100",
  "0111111110",
  "1111111111",
  "1101111011",
  "0100110010",
  "0000110000",
];

const MISSILE_GRID = [
  "0001000",
  "0010100",
  "1011101",
  "1111111",
  "0111110",
  "0011100",
  "0011100",
  "0011100",
  "0011100",
  "0011100",
  "0011100",
  "0001000",
];

const shapeFor = (id) => {
  const keys = ["a", "b", "c"];
  let sum = 0;
  for (let i = 0; i < String(id).length; i++) sum += String(id).charCodeAt(i);
  return GRIDS[keys[sum % keys.length]];
};

function gridToShadow(grid, px, color) {
  const parts = [];
  grid.forEach((row, y) => {
    for (let x = 0; x < row.length; x++) {
      if (row[x] === "1") parts.push(`${x * px}px ${y * px}px 0 ${color}`);
    }
  });
  return parts.join(",");
}

export function PixelSprite({ id, color, px = 4, boss = false, ship = false, missile = false, className = "" }) {
  const grid = boss ? BOSS_GRIDS[boss] || BOSS_GRIDS.invader : ship ? SHIP_GRID : missile ? MISSILE_GRID : shapeFor(id);
  const w = grid[0].length * px;
  const h = grid.length * px;
  return (
    <div style={{ width: w, height: h, position: "relative" }} aria-hidden="true" className={className}>
      <div
        style={{
          position: "absolute",
          width: px,
          height: px,
          background: color,
          boxShadow: gridToShadow(grid, px, color),
          top: 0,
          left: 0,
        }}
      />
    </div>
  );
}
